module.exports = __webpack_public_path__ + "static/media/melanoma.c0bdf124.svg";